import "./style.css";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppContext } from "../../../contexts/AppContextProvider";
import useOnClickOutside from "@hooks/useOnClickOutside";
// import logo from "../../../Assets/Images/lendriva-logo.png";
import logo from '../../../Assets/Images/Lenlogooo.svg'

interface ProtectedLayoutProps {
  children?: React.ReactNode;
  handleMenuToggle: () => void;
}

const Header: React.FC<ProtectedLayoutProps> = ({ handleMenuToggle }) => {
  const { value, setValue } = useAppContext();
  const [isOpen, setIsOpen] = useState(false);
  const [navbarOpen, setNavbarOpen] = useState(false);
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState(
    value?.user?.profileImage || null
  );
  const ref = useRef(null);

  useEffect(() => {
    setProfileImage(value?.user?.profileImage);
  }, [value?.user?.profileImage]);

  const handleClickOutside = () => {
    setIsOpen(false);
  };

  useOnClickOutside(ref, handleClickOutside);

  return (
    <>
      <section className="header">
        <div className="container p-0">
          <nav className="navbar navbar-expand-lg">
            <div className="container-fluid header-bg p-0">
              
              <a className="navbar-brand" href="/">
                <img src={logo} alt="" className="img-fluid" />
              </a>
              <button
                className="navbar-toggler"
                type="button"
                // data-bs-toggle="collapse"
                // data-bs-target="#navbarNav"
                // aria-controls="navbarNav"
                // aria-expanded="false"
                // aria-label="Toggle navigation"
                onClick={() => setNavbarOpen(!navbarOpen)}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className={`collapse navbar-collapse ${navbarOpen ? "show" : ""}`} id="navbarNav">
                <ul className="navbar-nav ms-auto">
                  {/* <li className="nav-item">
                    <Link to="/products" className="nav-link active" aria-current="page">
                      Product
                    </Link>
                  </li> */}
                  <li className="nav-item">
                    <Link to="/how-it-works" className="nav-link">How it works</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/security" className="nav-link">Security</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/faq" className="nav-link">FAQs</Link>
                  </li>
                </ul>
                <div className="button-block d-flex align-items-center">
                  
                  <div className="filled-btn">
                    <Link to="/auth/signup" className="btn-filled-blue">
                      Get Started
                    </Link>
                  </div>
                  <div className="outlined-btn">
                    <Link to="/auth/login" className="btn-outline-blue">
                      Sign In 
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </section>
    </>
  );
};

export default Header;
